"use client";
import { ReactNode, Suspense, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./theme";
import { AuthenticatedHeader } from "./headers/Header.Authenticated";
import ScrollToTop from "@/component/common/ScrollToTop";
import Image from "next/image";
import { MobileFooterMenu } from "./footers/FixedAuthFooter";
import logo_1 from "@/assets/img/logo/logo.png";
import { useSession } from "@/component/SessionProvider";
import { usePathname } from "next/navigation";
import { Maintenance } from "@/app/maintenance/components/Maintenance";
import { Verify2FA } from "@/component/Dashboard/components/Verify2FA";
import { VerifyEmail } from "@/component/Dashboard/components/VerifyEmail";

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap"); // eslint-disable-line
}

// fetch the start and target time from the server or define them here
const startTime = "2025-05-31T15:00:00.000Z";
const targetTime = "2025-05-31T23:00:00.000Z";

const Wrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { session, revalidateSession } = useSession();
  const route = usePathname();
  const isHome = route === "/";

  const getMaintenanceModeStatus = () => {
    const currentTime = new Date().toISOString();
    return (
      new Date(currentTime) >= new Date(startTime) &&
      new Date(currentTime) <= new Date(targetTime)
    );
  };

  useEffect(() => {
    const timeStart = !!startTime && new Date(startTime); // May 7, 2025 15:00:00 GMT
    const timeEnd = !!targetTime && new Date(targetTime); // May 7, 2025 17:10:00 GMT
    if (!timeStart || !timeEnd) return;
    const now = new Date(); // UTC

    const timeToStartFromNow = timeStart.getTime() - now.getTime();

    setTimeout(() => {
      setIsMaintenanceMode(getMaintenanceModeStatus());
    }, timeToStartFromNow);
  }, []);

  const _isAuthenticatedAndNotAdmin =
    session.isAuthenticated && !isHome && !session.user?.isAdmin;

  const [isMaintenanceMode, setIsMaintenanceMode] = useState(
    getMaintenanceModeStatus()
  );

  const onMaintenanceComplete = () => {
    setIsMaintenanceMode(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <AuthenticatedHeader />

      <Suspense fallback={<LoadingPage />}>
        {
          // isAuthenticatedAndNotAdmin &&
          isMaintenanceMode ? (
            <Maintenance
              startTime={startTime}
              targetTime={targetTime}
              onMaintenanceComplete={onMaintenanceComplete}
            />
          ) : (
            <div className="pb-20">{children}</div>
          )
        }

        {session.isAuthenticated && !isHome && <Verify2FA />}
        {session.user && !isHome && (
          <VerifyEmail
            account={session.user}
            refetch={() => {
              revalidateSession();
            }}
          />
        )}
      </Suspense>

      <ScrollToTop />
      <ToastContainer position="top-center" theme="light" autoClose={3500} />
      {session.isAuthenticated && !isHome && <MobileFooterMenu />}
    </ThemeProvider>
  );
};

const LoadingPage = () => {
  return (
    <div
      style={{ height: "100vh" }}
      className="w-full h-full flex justify-center items-center"
    >
      <Image className="animate-pulse" src={logo_1} style={{}} alt="iko" />
    </div>
  );
};

export default Wrapper;
